import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { useApprovalCheck } from './ApprovalCheckProvider/hook';
export function ApprovalCheckError() {
    const { error } = useApprovalCheck();
    if (!error) {
        return null;
    }
    const messages = {
        credits: t({
            comment: 'Document approval check - The company has no more assistant credits',
            message: 'You have insufficient credits on your account to do this action',
        }),
        setup: t({
            comment: 'Document approval check - There was an error setting up the approval check',
            message: 'Something went wrong when setting up the approval check, please try again.',
        }),
        streaming: t({
            comment: 'Document approval check - error when there was an error streaming the response',
            message: 'Something went wrong when running the approval check, please try again.',
        }),
    };
    return <Alert appearance="danger" message={messages[error]}/>;
}
